/**
 * conceptArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const conceptArtPack: ToilePack = {
    slug: 'concept-art',
    category: 'conceptart',
    name: 'Concept art',
    tagline: tagline('pieces', 'environments', 'treatments'),
    chips: chips('environments', 'treatments'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'city', label: 'Floating city', subject: 'stacked stone islands chained above a sea of cloud, airship docks'},
        {key: 'temple', label: 'Ancient temple', subject: 'a temple swallowed by jungle, roots in the steps, a flooded court'},
        {key: 'market', label: 'Cyber market', subject: 'a night alley of layered signage, cables and steaming food stalls'},
    ],
    styles: [
        {key: 'keyframe', label: 'Painterly keyframe', style: 'a finished full-color painting, loose confident brushwork', palette: 'dramatic light, atmospheric perspective', framing: 'wide shot, small figures for scale'},
        {key: 'lines', label: 'Line exploration', style: 'four black-line thumbnails drawn side by side', palette: 'structure only, no color', framing: 'exploration sheet on white'},
        {key: 'value', label: 'Value study', style: 'greyscale masses of light and dark, soft edges', palette: 'no color, fog between the planes', framing: 'wide shot, small figures for scale'},
    ],
    directions: ['a desert canyon instead', 'at dawn, low warm light', 'colder and more ruined'],
}
